import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { RootState, store } from './config/store';
import App from './App';
import { restoreCart } from './actions/cart';
import AuthProvider from './providers/AuthProvider';
import fetchAllCategories from './actions/categories';
import { Category, Country } from './types';
import fetchAllCountries from './actions/countries';
export interface ProvidersProps {}
store.dispatch(restoreCart());
store.dispatch(fetchAllCategories() as any);
store.dispatch(fetchAllCountries() as any);
  
const Providers: React.FC<ProvidersProps> = () => {
  return (
    <ReduxProvider store={store}>
      <AuthProvider>
          <App />
      </AuthProvider>
    </ReduxProvider>

  );
};

export default Providers;
